export default {
  default: () => import("/opt/build/repo/layouts/default.vue"),
  "no-header-or-footer": () => import("/opt/build/repo/layouts/no-header-or-footer.vue")
}